import { makeAutoObservable } from "mobx";
import { promotionEffectPrice } from "../PromotionType";
import { Price } from "../Price";
export class ProductPromotionInstance {
    constructor(params) {
        this.kind = "Product";
        this.id = params.id;
        this.promotionType = params.promotionType;
        this._active = params.active;
        this.discountSource = params.discountSource;
        this.discountTarget = params.discountTarget;
        makeAutoObservable(this);
    }
    get active() {
        return this._active;
    }
    setActive(active) {
        this._active = active;
    }
    get value() {
        if (!this.active) {
            return Price.free();
        }
        return promotionEffectPrice(this.promotionType.effect, this.discountTarget.price);
    }
    get checkoutData() {
        const value = this.value.finalValue;
        return {
            promotionId: this.promotionType.id.value,
            promotionalItemId: this.id.value,
            source: this.discountSource.map((orderLineReference) => orderLineReference.checkoutData).raw,
            input: { tag: "NoInput" },
            active: this.active,
            assignment: this.discountTarget.checkoutData,
            value: value ? value.cents : null,
        };
    }
}
